import React from "react";

const ProjectScheduleCost = ({ pfrFormData, setPfrFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPfrFormData("projectScheduleCost", {
      [name]: value,
    });
  };

  return (
    <>
      <div className="form-section">
        <h3>Project Schedule & Cost</h3>
        <div className="form-group">
          <label className="required">
            Likely date of start of construction and likely date of completion
            (time schedule for the project to be given).
          </label>
          <textarea
            type="text"
            name="likelyDateOfStartOfConstruction"
            value={
              pfrFormData.projectScheduleCost.likelyDateOfStartOfConstruction
            }
            onChange={handleInputChange}
            placeholder="Enter Likely date of start of construction"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">
            Estimated Project cost along with analysis in terms of economic
            viability of the project.
          </label>
          <textarea
            type="text"
            name="estimatedProjectCost"
            value={pfrFormData.projectScheduleCost.estimatedProjectCost}
            onChange={handleInputChange}
            placeholder="Enter Estimated Project cost"
            required
          />
        </div>
      </div>
    </>
  );
};

export default ProjectScheduleCost;
